import { Button as ButtonBase } from './button';
import { ButtonGroup } from './button-group';

export const Button = Object.assign(ButtonBase, {
  Group: ButtonGroup,
});

export type { ButtonProps, ButtonGroupProps } from './button.types';
